import React from 'react';
import { faNumber } from 'utils/common.util';
import { SOff } from './style';

const OffBadge: React.FC<{ off: number }> = ({ off }) => {
  return off === 0 ? null : <SOff>{faNumber(off)}%</SOff>;
};

export default OffBadge;
